import { Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import { AuthProvider } from './utils/auth'
import HomePage from './pages/HomePage'
import FeaturesPage from './pages/FeaturesPage'
import HowItWorksPage from './pages/HowItWorksPage'
import PrivacyPage from './pages/PrivacyPage'
import PricingPage from './pages/PricingPage'
import LoginPage from './pages/LoginPage'
import RegisterPage from './pages/RegisterPage'
import ForgotPasswordPage from './pages/ForgotPasswordPage'
import ResetPasswordPage from './pages/ResetPasswordPage'
import DashboardPage from './pages/DashboardPage'
import CheckoutSuccessPage from './pages/CheckoutSuccessPage'
import DownloadPage from './pages/DownloadPage'
import StealthPage from './pages/StealthPage'
import CompatibilityPage from './pages/CompatibilityPage'

function App() {
  return (
    <AuthProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="/how-it-works" element={<HowItWorksPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
          <Route path="/download" element={<DownloadPage />} />
          <Route path="/stealth" element={<StealthPage />} />
          <Route path="/is-it-safe" element={<StealthPage />} />
          <Route path="/compatibility" element={<CompatibilityPage />} />
          <Route path="/platforms" element={<CompatibilityPage />} />
        </Routes>
      </Layout>
    </AuthProvider>
  )
}

export default App
